import { createScaffolderFieldExtension as createScaffolderFieldExtension$1, ScaffolderFieldExtensions as ScaffolderFieldExtensions$1, useTemplateSecrets as useTemplateSecrets$1, scaffolderApiRef as scaffolderApiRef$1, createScaffolderLayout as createScaffolderLayout$1, ScaffolderLayouts as ScaffolderLayouts$1 } from '@backstage/plugin-scaffolder-react';
import { rootRouteRef as rootRouteRef$1 } from './routes.esm.js';

const rootRouteRef = rootRouteRef$1;
const createScaffolderFieldExtension = createScaffolderFieldExtension$1;
const ScaffolderFieldExtensions = ScaffolderFieldExtensions$1;
const useTemplateSecrets = useTemplateSecrets$1;
const scaffolderApiRef = scaffolderApiRef$1;
const createScaffolderLayout = createScaffolderLayout$1;
const ScaffolderLayouts = ScaffolderLayouts$1;

export { ScaffolderFieldExtensions, ScaffolderLayouts, createScaffolderFieldExtension, createScaffolderLayout, rootRouteRef, scaffolderApiRef, useTemplateSecrets };
//# sourceMappingURL=deprecated.esm.js.map
